var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-shared-tips-line",class:{
        'c-shared-tips-line--credit': _vm.isCredit,
        'c-shared-tips-line--vertical': _vm.isVertical,
        'c-shared-tips-line--centered': _vm.isCenterOverwrite,
        'c-shared-tips-line--purple': _vm.isLinePurple
    }},[_c('div',{staticClass:"c-shared-tips-line__inner"})])}
var staticRenderFns = []

export { render, staticRenderFns }